module.exports = __webpack_public_path__ + "static/media/space.7c6a1f8a.svg";